import Menu from './menu';
import HeroContactTab from './hero-contact-tab';
import Hero from './hero';
import Forms from './forms';
import DesignConsistency from './design-consistency';
import Media from './media';
import Lazy from './lazy-loading';
import './lib/form-filter';
import './widgets';
import './links';
import './faq-search'; // added before accordeon search because it handles events triggered in accordeon search.
import './accordeon-search';
import './faq-link';
import '@babel/polyfill/noConflict';
import 'owl.carousel';
import AddClassToRow from './add-class-to-row';

class JelloChild {
  /**
   * Sets necessary variables for this class
   * that are used throughout
   */
  constructor() {
    this.name = 'Jello Child Theme';
    this.menu = new Menu();
    this.heroContactTab = new HeroContactTab();
    this.hero = new Hero();
    this.media = new Media();
    this.Lazy = new Lazy();
    this.AddClassToRow = new AddClassToRow();

    // Selectors
    this.vacancies = $('.vacancies');
    this.loadingOverlay = $('.loading-overlay');
    this.afas = $('.embed-responsive-item');
    this.main = $('main');
  }

  /**
   * Initializes all needed functions
   */
  init() {
    this.heroContactTab.init();
    this.hero.init();
    this.Lazy.init();
    this.setVacanciesFilter();
    this.hideShowVacanciesAfterAnimation();
    this.toggleAfasForm();
    this.modals();
    this.showreel();
    this.sustainableDevelopmentGoals();
    this.AddClassToRow.init();

    JelloChild.makeEntireAreaLinkToSocialSite();
    JelloChild.pushDownRowBelowRowWithOffset();

    JelloChild.updateTimelineMeter();
    JelloChild.handleTimelineModalIntroductionTab();
    JelloChild.handleTimelineModalPagination();
    JelloChild.gfPriceBaseFix();
    JelloChild.addOffsetToHalfCircle();
    JelloChild.linkableCards();

    Forms.init();
    DesignConsistency.init();

    $('html').attr('class', 'js');

    this.removeLoadingOverlay();
    JelloChild.scrollCenterX();
  }

  setVacanciesFilter() {
    if (!this.vacancies.length) {
      return;
    }

    $('.vacancies-filter').formFilter({
      target: '.item-vacancy',
      exception: $('.vacancies-filter').data('exception'),
    });
  }

  toggleAfasForm() {
    if (!this.afas.length) {
      return;
    }

    $('#show_afas_form').on('click', (e) => {
      e.preventDefault();
      let height = 1500;

      if (!this.media.large) {
        height = 3300;
      }

      $('#solliciteren').animate({
        height: `${height}px`,
      }, 500);
    });
  }

  hideShowVacanciesAfterAnimation() {
    if (!this.vacancies.length) {
      return;
    }

    $('.item-vacancy', this.vacancies).each((index, el) => {
      el.addEventListener('formfilter.hide', () => {
        $(el).animate({
          opacity: 0,
        }, 200, function takeOutOfFlow() {
          $(this).hide();
        });
      });

      el.addEventListener('formfilter.show', () => {
        $(el)
          .show()
          .animate({
            opacity: 1,
          }, 200);
      });
    });
  }

  removeLoadingOverlay() {
    this.loadingOverlay.hide(0);
  }

  modals() {
    $('.modal').on('show.bs.modal', () => {
      this.main.css('position', 'static');
    });

    $('.modal').on('hidden.bs.modal', () => {
      this.main.css('position', 'relative');
    });
  }

  showreel() { // eslint-disable-line class-methods-use-this
    const showreel = $('.showreel.owl-carousel').owlCarousel({
      items: 1,
      loop: true,
      dots: false,
      nav: false,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1200: {
          items: 3,
        },
      },
    });

    // Custom navigation
    $('.showreel-nav .nav-prev').on('click', () => showreel.trigger('prev.owl.carousel'));
    $('.showreel-nav .nav-next').on('click', () => showreel.trigger('next.owl.carousel'));
  }

  sustainableDevelopmentGoals() { // eslint-disable-line class-methods-use-this
    const goals = document.querySelectorAll('.sustainable-development-goals li');

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const viewportWidth = window.innerWidth;
        const halfOfViewportWidth = viewportWidth / 2;

        const position = entry.target.getBoundingClientRect();

        entry.target.classList.remove('left');

        if (position.x < halfOfViewportWidth) {
          entry.target.classList.add('left');
        }
      });
    });

    goals.forEach((goal) => {
      resizeObserver.observe(goal);

      goal.addEventListener('click', (e) => {
        const body = document.querySelector('body');
        const currentlyVisible = e.currentTarget.classList.contains('show');

        goals.forEach(g => g.classList.remove('show'));

        if (!currentlyVisible) {
          e.currentTarget.classList.add('show');
        }

        const goalContent = e.currentTarget.querySelector('.sustainable-goal-content');

        const position = e.currentTarget.getBoundingClientRect();
        goalContent.dataset.top = position.y + window.scrollY;
        goalContent.dataset.left = position.x + window.scrollX;

        if (goalContent) {
          let { left } = goalContent.dataset;

          if (window.innerWidth < 550) {
            left = 15;
          }

          goalContent.style.setProperty('top', `${goalContent.dataset.top}px`);
          goalContent.style.setProperty('left', `${left}px`);

          body.appendChild(goalContent);

          goalContent.classList.add('show-sustainable-goal-content');
        }

        e.preventDefault();
        e.stopImmediatePropagation();
      });
    });

    document.querySelectorAll('.sustainable-development-goals .close-link').forEach((closeLink) => {
      closeLink.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });

    document.querySelector('body').addEventListener('click', (e) => {
      if (e.currentTarget.classList.contains('sustainable-development-goals-container')) {
        return;
      }

      goals.forEach(g => g.classList.remove('show'));

      const openGoal = document.querySelector('.show-sustainable-goal-content');

      if (openGoal) {
        const li = document.getElementById(openGoal.dataset.liId);

        if (li) {
          openGoal.classList.remove('show-sustainable-goal-content');
          li.appendChild(openGoal);
        }
      }
    });
  }

  static linkableCards() {
    const cards = document.querySelectorAll('.linkable-card');
    if (!cards) {
      return;
    }
    cards.forEach((card) => {
      const row = card.closest('.vc_row');
      if (row) {
        row.classList.add('has-linkable-cards');
      }
    });
  }

  static gfPriceBaseFix() {
    if (typeof toolkit === 'object' && toolkit.formID) {
      const gformId = toolkit.formID;

      $(`.page-toolkit-bestelpagina #gform_${gformId} .gfield_calculation input[id^=ginput_base_price]`).off().on('change', () => {
        const newTotal = JelloChild.calculateToolkitTotal();
        const formattedTotal = `€ ${newTotal.toFixed(2).replace('.', ',')}`;

        $(`#gform_${gformId} .ginput_container_custom_total .gform_hidden`).val(newTotal);
        $(`#gform_${gformId} .ginput_container_custom_total .ginput_custom_total`).text(formattedTotal);
      });
    }
  }

  static calculateToolkitTotal() {
    let total = 0;

    $('.page-toolkit-bestelpagina .ginput_container_product_calculation').each(function addToTotal() {
      const quantity = $('.ginput_quantity', this)[0].value;

      if (quantity > 0) {
        const valueInput = $('.gform_hidden[id^=ginput_base_price]', this);
        const calculatedValue = valueInput[0].value.replace('€ ', '').replace(/[^0-9,]/g, '').replace(',', '.');

        total += parseFloat(calculatedValue);
      }
    });

    return total;
  }

  static updateTimelineMeter() {
    $('.timeline-modal a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
      const tab = e.target;
      const modal = $(e.target).parents('.modal')[0];
      const effortMeter = modal.querySelector('.meter-effort');
      const impactMeter = modal.querySelector('.meter-impact');
      const { effort, impact } = tab.dataset;

      if (effort && effortMeter) {
        effortMeter.style.setProperty('--value', effort);
      }

      if (impact && impactMeter) {
        impactMeter.style.setProperty('--value', impact);
      }
    });
  }

  static handleTimelineModalIntroductionTab() {
    const introductionTab = $('.timeline-modal .nav-timeline-introduction a[data-toggle="tab"]');

    introductionTab.on('shown.bs.tab', (e) => {
      const modal = $(e.target).parents('.modal')[0];
      const timelineMetersWrap = modal.querySelector('.meters-wrap');

      if (timelineMetersWrap) {
        timelineMetersWrap.style = 'opacity: 0;';
      }
    });

    introductionTab.on('hide.bs.tab', (e) => {
      const modal = $(e.target).parents('.modal')[0];
      const timelineMetersWrap = modal.querySelector('.meters-wrap');

      if (timelineMetersWrap) {
        timelineMetersWrap.style = null;
      }
    });
  }

  /**
   * Centers the scrollbar on elements which have overflowing content
   */
  static scrollCenterX() {
    const scrollables = document.querySelectorAll('.scroll-center-x');

    scrollables.forEach((scrollable) => {
      const scrollEl = scrollable;
      scrollEl.scrollLeft = (scrollEl.scrollWidth - scrollEl.offsetWidth) / 2;
    });
  }

  static handleTimelineModalPagination() {
    const paginationLinks = document.querySelectorAll('.timeline-modal-pagination a[data-trigger-tab]');

    paginationLinks.forEach((link) => {
      const target = link.dataset.triggerTab;

      link.addEventListener('click', (e) => {
        e.preventDefault();

        $(target).tab('show');
      });
    });
  }

  static makeEntireAreaLinkToSocialSite() {
    const items = document.querySelectorAll('footer #menu-social .menu-item');

    if (!items) {
      return;
    }

    items.forEach((item) => {
      item.addEventListener('click', (e) => {
        const anchor = e.currentTarget.querySelector('a');
        anchor.click();
      });
    });
  }

  static pushDownRowBelowRowWithOffset() {
    const rowsWithOffset = document.querySelectorAll('.row-overflow-into-next');

    if (!rowsWithOffset || !rowsWithOffset.length) {
      return;
    }

    rowsWithOffset.forEach((row) => {
      let rootRow = row;

      if (row.classList.contains('vc_inner')) {
        rootRow = row.closest('.vc_row:not(.vc_inner)');
      }

      if (rootRow) {
        rootRow.style.overflow = 'visible';

        let nextRealRow = rootRow.nextElementSibling;

        while (nextRealRow && !nextRealRow.classList.contains('vc_row')) {
          nextRealRow = nextRealRow.nextElementSibling;
        }

        if (nextRealRow) {
          nextRealRow.classList.add('follows-row-with-overflow');
        }
      }
    });
  }

  static calculateOffsetToElementWithClass(element, className) {
    let offset = 0;
    let el = element;

    while (el != null && !el.matches(className)) {
      offset += el.offsetTop;
      el = el.offsetParent;
    }

    return offset;
  }

  static addOffsetToHalfCircle() {
    const selector = '.add-half-circle';
    const halfCircles = document.querySelectorAll(selector);
    
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const halfCircle = entry.target;
        const container = halfCircle.querySelector('.hero-children-container');
      
        const titles = container.querySelectorAll('h2, .h2, h3, .h3');

        if (titles && titles.length) {
          let offset = JelloChild.calculateOffsetToElementWithClass(titles[0], 'body');

          const headerHeight = document.querySelector('header.header').offsetHeight;
          offset -= headerHeight; // subtract sticky header

          const showHalfCircle = titles[0].getBoundingClientRect().left > 80;

          if (showHalfCircle) {
            halfCircle.style.setProperty('--half-circle-opacity', 100);
            halfCircle.style.setProperty('--half-circle-inset-block-start', `${offset}px`);
          } else {
            halfCircle.style.setProperty('--half-circle-opacity', 0);
          }
        }
      });
    });

    halfCircles.forEach((halfCircle) => {
      const hasHero = halfCircle.querySelector('.hero');

      if (hasHero) {
        resizeObserver.observe(halfCircle);
      } else {
        const titles = halfCircle.querySelectorAll('h2, .h2, h3, .h3');

        if (titles && titles.length) {
          const offset = JelloChild.calculateOffsetToElementWithClass(titles[0], selector);

          halfCircle.style.setProperty('--half-circle-inset-block-start', `${offset}px`);
        }
      }
    });
  }
}

$(() => {
  const jc = new JelloChild();
  jc.init();
});
